import * as React from 'react'
import { ReactEventHandler } from 'react'

type IQuickFilterButton = {
  leading?: React.ReactElement
  title: string
  onClickDrawer: ReactEventHandler
  onClickMenu: ReactEventHandler
  isActive: boolean
}

const baseClass =
  'flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 py-2 text-[13px] font-medium transition-colors duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800'

// blue-800 text on the tint: blue-500 text measured 2.7:1 (fails AA).
const activeClass = 'border-blue-800/40 bg-blue-500/10 text-blue-800'

const inactiveClass =
  'border-ink-100/20 bg-white-500 text-ink-700 hover:border-ink-100/40 hover:bg-cream-300'

export default function QuickFilterButton({
  leading,
  title,
  onClickDrawer,
  onClickMenu,
  isActive
}: IQuickFilterButton) {
  const stateClass = isActive ? activeClass : inactiveClass

  return (
    <div className="flex flex-row">
      {/* Mobile version */}
      <button
        type="button"
        onClick={onClickDrawer}
        className={`${baseClass} ${stateClass} md:hidden`}
      >
        {leading && (
          <span
            className={`text-xs ${isActive ? 'text-blue-800' : 'text-ink-200'}`}
          >
            {leading}
          </span>
        )}
        <span>{title}</span>
      </button>

      {/* Desktop version */}
      <button
        type="button"
        onClick={onClickMenu}
        className={`${baseClass} ${stateClass} hidden md:flex`}
      >
        {leading && (
          <span
            className={`text-xs ${isActive ? 'text-blue-800' : 'text-ink-200'}`}
          >
            {leading}
          </span>
        )}
        <span>{title}</span>
      </button>
    </div>
  )
}
